import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function RegistrationModeFormatter({ info }) {
  const { value } = getInfo(info)
  const registration = REGISTRATION_MODE_OPTIONS[value]

  if (!registration) {
    return '--'
  }

  return registration
}

const REGISTRATION_MODE_OPTIONS = {
  all: 'All registrations',
  confirmation: 'E-mail Confirmation',
}
